import React, { ReactNode } from 'react';
import { HelmetProvider } from 'react-helmet-async';

type Props = {
  children: ReactNode;
};

export function HelmetProviderAsync(props: Props) {
  const { children } = props;
  return <HelmetProvider>{children}</HelmetProvider>;
}
